import CookiesPolicy from "@/components/conditions/cookies-policy";
import { useRouter } from "next/router";
import { useEffect } from "react";

const CookiePolicy = () => {
    const router = useRouter();

    useEffect(() => {
        if (!localStorage.getItem('isCookiePolicyViewed')) {
            localStorage.setItem('isCookiePolicyViewed', 'yes');
            router.reload();
        }
    }, []);
    return (
        <CookiesPolicy showFooter={true} />
    );
};

export default CookiePolicy;
